module.exports = __webpack_public_path__ + "img/manual_transaksi.3c0629e2.svg";